import React, { useState } from "react";
import "./Login.css";
import { useFirebase } from "../../../context/Firebase";
import { useNavigate, Link } from "react-router-dom";

const LoginPage = () => {
  const firebase = useFirebase();

  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Reset error

    try {
      // Step 1: Firebase Auth Signin
      const userCredential = await firebase.signinUserWithEmailAndPass(email, password);
      const user = userCredential.user;

      // Step 2: Get user data from Firestore
      const userDoc = await firebase.getUserFromFirestore(user.uid);
      if (!userDoc.exists()) {
        setError("User record not found in Firestore.");
        return;
      }

      const userData = userDoc.data();

      // Step 3: Admin-only check
      if (userData.isBlocked) {
        setError("Your account is temporarily blocked.");
        return;
      }

      if (!userData.isAdmin) {
        setError("You are not authorized to log in as an admin.");
        return;
      }

      // ✅ Step 4: All good — go to admin
      navigate("/admin");
    } catch (err) {
      console.error(err);
      setError("Wrong email or password.");
    }
  };

  return (
    <div className="modern-login-page">
      {/* Decorative floating orbs */}
      <div className="glass-orbs">
        <div className="glass-orb glass-orb-1"></div>
        <div className="glass-orb glass-orb-2"></div>
        <div className="glass-orb glass-orb-3"></div>
      </div>

      {/* Left Side - Login Form */}
      <div className="login-left-section">
        <div className="login-form-container">
          <div className="login-header">
            <h1 className="login-title">Jiremali Samaj</h1>
            <h2 className="login-welcome">Welcome back</h2>
            <p className="login-subtitle">Login to your admin account</p>
          </div>

          {error && <div className="login-error">{error}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                id="email"
                type="email"
                placeholder="m@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <div className="form-label-row">
                <label htmlFor="password" className="form-label">Password</label>
                <button type="button" className="forgot-password">Forgot your password?</button>
              </div>
              <input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                required
              />
            </div>

            <button type="submit" className="login-button">
              Login
            </button>

            <div className="signup-link">
              Don't have an account? <Link to="/register">Sign up</Link>
            </div>
          </form>

          <div className="login-footer">
            By clicking continue, you agree to our <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy Policy</a>
          </div>
        </div>
      </div>

      {/* Right Side - Video */}
      <div className="login-right-section">
        <div className="right-content-placeholder">
          {/* TheCodersHub Video */}
          <video 
            src="/theCodersHub.mp4" 
            className="login-right-image"
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;